import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SupplierCreditNoteReducer } from '../reducers';

export const SupplierCreditNoteFeature = createFeatureSelector<SupplierCreditNoteReducer.DataState>(SupplierCreditNoteReducer.featureName);

export const SelectSupplierCreditNote = createSelector(SupplierCreditNoteFeature, (state: SupplierCreditNoteReducer.DataState) => state.item);
